module.exports = __webpack_public_path__ + "img/11.dc8c59e3.svg";